/**
 * Which actions an undo is allowed to reach.
 *
 * Every action the backend records carries a scope, and this says which scopes
 * count right now. It is derived from what is on screen rather than accumulated
 * as things are selected, which is where it departs from upstream: there, scopes
 * are merged into a mutable set as a workspace or application is chosen and
 * nulled again when it is left, and the store carries a FIXME about exactly what
 * that costs -- a `table` left behind by a route change makes an undo reach into
 * a table nobody is looking at. Derived, there is nothing to leave behind.
 *
 * `root` is always included. Actions with no narrower scope -- creating a
 * workspace, reordering them -- belong to the shell itself, which is on screen
 * whenever undo is reachable at all.
 */
export interface ActionScopes {
  root: true
  workspace?: number
  application?: number
  table?: number
  view?: number
}

export interface ScopeSource {
  workspaceId?: number | undefined
  applicationId?: number | undefined
  tableId?: number | undefined
  viewId?: number | undefined
}

export function undoScopes(source: ScopeSource): ActionScopes {
  const scopes: ActionScopes = { root: true }

  // Absent rather than null. The endpoint reads both the same way, and a body
  // carrying only what is true is the one that reads correctly in a request log.
  if (source.workspaceId !== undefined) scopes.workspace = source.workspaceId
  if (source.applicationId !== undefined) scopes.application = source.applicationId
  if (source.tableId !== undefined) scopes.table = source.tableId
  if (source.viewId !== undefined) scopes.view = source.viewId

  return scopes
}
